module.exports = __webpack_public_path__ + "static/media/lb-prev.14261edc.svg";